import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";
import utils        from "../../Utils";
import Constants    from "../../Constants";

// import overlayscrollbars
import 'overlayscrollbars/css/OverlayScrollbars.css';
import {OverlayScrollbarsComponent, OverlayScrollbarsPlugin} from 'overlayscrollbars-vue';

// global registration
Vue.component('overlay-scrollbars', OverlayScrollbarsComponent);

const components = _.merge(ComponentSet,
    {
        'overlay-scrollbars': OverlayScrollbarsComponent
    });
// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data: { 
        
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData();
    },
    methods: {
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        branchHasData() {
            let branch     = _.get(this, 'contentData.branchList', []);
            let centerList = _.get(this, 'contentData.centerList', []);
            let removeIds = [];
            // 如果 Branch 底下沒有任何實驗室要移除掉
            _.forEach(branch, function(value) {
                _.forEach(centerList, function(centerCollection) {
                    if(centerCollection.Key.BranchId == value.Id){
                        if(centerCollection.Key.ResearchPlaceTypeId == 1){
                            value.institutes = centerCollection;
                        }else{
                            value.centers = centerCollection;
                        }
                    }
                });
                // 將沒有資料的 Branch Id 記起來
                if(_.isEmpty(_.get(value, 'institutes')) && _.isEmpty(_.get(value, 'centers'))){
                    removeIds.push(value.Id);
                }
            });
            // 將沒有資料的 Branch 移除
            let data;
            if(removeIds.length >0){
                _.forEach(removeIds, function(value) {
                    data = _.reject(branch, function(o) { return o.Id == value; });
                }); 
            }else{
                data = branch;
            }
            return data;
        },
    }, // end of computed
}).$mount('#app');